import request from "@/app/api/request";
import {ChatModel, ChatsByUsernameRequestsModel, ChatsRequestsModel, MessageModel} from "@/app/api/chat/models";

export class ChatRequests {
  static async getChats(page: number): Promise<ChatModel[]> {
    const query: ChatsRequestsModel = {page, size: 10};
    try {
      return await request.get<ChatModel[]>('/chats/userChats', {query});
    } catch (error: any) {
      throw error;
    }
  }

  static async getChatByUsername(username: string): Promise<ChatModel[]> {
    const query: ChatsByUsernameRequestsModel = {username};
    try {
      return await request.get<ChatModel[]>('/chats/getChatsByUsername', {query});
    } catch (error: any) {
      throw error;
    }
  }

  static async addParticipant(chatId: number, userId: number): Promise<ChatModel[]> {
    try {
      return await request.post<ChatModel[]>('/chats/addParticipant', {query: {chatId, userId}});
    } catch (error: any) {
      throw error;
    }
  }

  static async createChat(users: number[]): Promise<ChatModel> {
    try {
      return await request.post<ChatModel>('/chats/create', {data: users});
    } catch (error: any) {
      throw error;
    }
  }

  static async uploadImage(model: FormData): Promise<string> {
    try {
      return await request.post<string>('/user/uploadFileToS3', {
        data: model,
        config: {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      });
    } catch (error: any) {
      throw error;
    }
  }
}

